import React, { Component } from 'react';
import InputText from '../../../../commonModules/interface/form-input-inline';
import PopUp from '../../../../commonModules/interface/PopUp';
import { Button, TableRow, TableCell, TableHead, TableBody, IconButton } from '@material-ui/core';
import { TableLayout } from '../containers/Layout';
import { AddCircleOutline, CloseRounded } from '@material-ui/icons';

class PriceList extends Component {
    state = { 
        nbLine: this.props.nbLine || 1,
        prices: this.props.nbLine > 0 ? this.props.price_list : [
            {
                price_quantity: "",
                price_sell: "",
                price_sell_pro: "",
            }
        ],
        // errors: [
        //     {
        //         price_quantity: "",
        //         price_sell: "",
        //     }
        // ],
        prix_venteHT: this.props.prix_venteHT,
        prix_venteHT_pro: this.props.prix_venteHT_pro || this.props.prix_venteHT
     }

    handleAddPrice = () => {
        this.setState({
            prices:[
                ...this.state.prices,
                {
                    price_quantity: "",
                    price_sell: "",
                    price_sell_pro: "",
                }
            ],
            // errors: [
            //     ...this.state.errors,
            //     {
            //         price_quantity: "",
            //         price_sell: "",
            //     }
            // ],
            nbLine : this.state.nbLine + 1
        })
    }
    createAddPrice = () => {
        const { nbLine } = this.state;
        let tab = []
        for(let i = 0; i < nbLine; i++){
            tab.push(
                <TableRow key={i}>
                    
                    <TableCell className="table-kwh1" > 
                        {i !== 0 &&
                            <IconButton 
                                type="button" 
                                className="delete-line" 
                                onClick={()=>this.handleDeleteProd(i)}
                            >
                                <CloseRounded color="error" />
                            </IconButton>
                        }
                        <InputText 
                            type="number" 
                            onChange={this.handleChange} 
                            name={`price_quantity-${i}`} 
                            value={this.state.prices[i].price_quantity} 
                            label="Quantité"
                        />
                        {/* <small className="help-block">{this.state.errors[i].price_quantity}</small>  */}
                    </TableCell>
                    <TableCell className="table-kwh2" > 
                        <InputText 
                            type="number" 
                            onChange={this.handleChange} 
                            name={`price_sell-${i}`} 
                            value={this.state.prices[i].price_sell} 
                            label="PU Particuliers"
                            helperText={this.state.prices[i].price_quantity && `PU Particuliers pour ${this.state.prices[i].price_quantity} produits achetés`}
                            
                        />
                        
                    </TableCell>
                    <TableCell className="table-kwh3" > 
                        <InputText 
                            type="number" 
                            onChange={this.handleChange} 
                            name={`price_sell_pro-${i}`} 
                            value={this.state.prices[i].price_sell_pro} 
                            label="PU Pro"
                            helperText={this.state.prices[i].price_quantity && `PU Pro pour ${this.state.prices[i].price_quantity} produits achetés`}
                        />
                    </TableCell>
                    
                </TableRow>
            )
        }
        return tab
    }
    
    handleDeleteProd = (index) => {
        this.setState({
            ...this.state,
            prices:[
                ...this.state.prices.slice(0,index),
                ...this.state.prices.slice(index +1),
            ],
            // errors:[
            //     ...this.state.errors.slice(0,index),
            //     ...this.state.errors.slice(index +1),   
            // ],

            nbLine:this.state.nbLine - 1,
        })   
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const ints = /^[0-9\b]+$/ // int only
        const floats = /^[+]?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        
        if(field.startsWith("price_")){

            let splitTab = field.split("-")
            let name = splitTab[0]
            let index = splitTab[1]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpPrices = [].concat(this.state.prices)
            
            if(name === "price_quantity") {   
                if(value === "" || ints.test(value)){// update value only if its a int
                    cpPrices[index][name] = parseInt(value)
                }
                
            } else if (name === "price_sell" || name === "price_sell_pro") {
                if(value === "" || floats.test(value)){// update value only if its a int
                    cpPrices[index][name] = parseFloat(value)
                }
            }

            this.setState({
                ...this.state,
                prices:cpPrices,
            })      
        } else if(value === "" || floats.test(value)) {
            this.setState({
                ...this.state,
                [field]: parseFloat(value),
            })  
        }
    }
    render() {
        console.log('====================================');
        console.log("STATE", this.state);
        console.log('====================================');
        // const submit = (
        //     <button 
        //         className="btn btn-info" 
        //         onClick={() => this.props.savePriceList(this.state.prices, this.state.prix_venteHT_pro)}
        //     >
        //         Valider
        //     </button>
        // )
        return (
            <PopUp 
                title="Grille des Prix" 
                close={this.props.handleClose} 
                // submit={submit}
                submitAction={() => this.props.savePriceList(this.state.prices, this.state.prix_venteHT_pro) }
                submitTitle="Valider"
            >
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Quantité</TableCell>
                            <TableCell>PU Particuliers</TableCell>
                            <TableCell>PU Professionnels</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell className="table-kwh1" > 
                                <InputText 
                                    type="number" 
                                    disabled 
                                    value={1} 
                                />
                            </TableCell>
                            <TableCell className="table-kwh2" > 
                                <InputText 
                                    type="number" 
                                    // onChange={this.handleChange}  
                                    // name="prix_venteHT"
                                    disabled
                                    value={this.props.prix_venteHT} 
                                />
                                <small className="help-block">Remplir dans le formulaire</small> 
                            </TableCell>
                            <TableCell className="table-kwh3" > 
                                <InputText 
                                    type="number"
                                    label="PU Pro" 
                                    onChange={this.handleChange}  
                                    name="prix_venteHT_pro"                
                                    value={this.state.prix_venteHT_pro} 
                                />
                            </TableCell>
                            
                        </TableRow>
                        {this.createAddPrice()}
                        <TableRow className="plus-btn" onClick={this.handleAddPrice}>
                            <TableCell colSpan={3}>
                                {/* <a> 
                                    <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"></i>
                                    <span>Ajouter un Prix</span> 
                                </a> */}
                                <Button
                                    startIcon={<AddCircleOutline />}
                                    color="primary"
                                >
                                    Ajouter un Prix
                                </Button>
                            </TableCell>
                        
                        </TableRow>
                    </TableBody>
                </TableLayout>            
            </PopUp>  
        );
    }
}

export default PriceList;